export default __webpack_public_path__ + "8a05798.mp3";